import axiosPost from '../axiosPost';

export const condicionesAFIPIns = async (arg) => {
    const { nombre, codigo, nombreAFIP } = arg;

    const body = {
        "service": "CondicionAFIPIns",
        "params": {
            "condicionAFIPNombre": nombre,
            "condicionAFIPCodigo": codigo,
            "condicionAFIPNombreAFIP": nombreAFIP,
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}